import { FilterStateKeys } from './filters.model'

export interface IPageQueryParamsMap {
  [key: string]: FilterStateKeys[]
}

export const AppVersion = '1'
export const NewVersionIndicator = 'new-version'

export const PageQueryParamsMap: IPageQueryParamsMap = {
  '/dashboard': [
    'dashboardGroup',
    'tireWidgetFilter',
    'contactsTypeWidgetFilter',
    'arReceivablesWidgetFilter'
  ],
  '/work-orders/summary': ['workOrdersSummaryFilter', 'workOrdersSummarySortState'],
  '/work-orders/list': [
    'workOrdersListFilters',
    'workOrdersListColumnsVisibility',
    'workOrdersListAdvancedMode'
  ],
  '/receivable/receivables-list': [
    'receivableListFilters',
    'receivableColumnsVisibility',
    'receivableListAdvancedMode',
    'receivableListReturnUrl'
  ],
  '/receivable/locations': ['shopReceivableSummaryFilter'],
  '/receivable/ar': ['arSummaryFilter', 'rangePickerType'],
  '/receivable/ar-payments': ['arPaymentsSummaryFilter'],
  '/receivable/ar-moving-average': ['arMovingAverageFilter'],
  '/receivable/accounts': ['accountReceivableFilter'],
  '/receivable/snapshot': ['receivableSnapshotFilter'],
  '/location-invoices/invoices-list': [
    'invoicesListFilters',
    'invoicesListColumnsVisibility',
    'invoicesListAdvancedMode',
    'invoicesListReturnUrl'
  ],
  '/location-invoices/invoices-list-overview': [
    'invoicesListFilters',
    'invoicesListColumnsVisibility',
    'invoicesListAdvancedMode',
    'invoicesListReturnUrl'
  ],
  '/location-invoices/invoice-lines-overview': ['invoiceLinesFilters', 'invoiceLinesListColumnsVisibility', 'invoiceLinesAdvancedMode'],
  '/location-invoices/invoice-lines-by-location': ['invoiceLinesFilters', 'invoiceLinesListColumnsVisibility', 'invoiceLinesAdvancedMode'],
  '/location-invoices/invoice-lines-by-advisor': ['invoiceLinesFilters', 'invoiceLinesListColumnsVisibility', 'invoiceLinesAdvancedMode'],
  '/location-invoices/invoice-lines-list': ['invoiceLinesFilters', 'invoiceLinesListColumnsVisibility', 'invoiceLinesAdvancedMode'],
  '/location-invoices/gross-invoices-list': [
    'grossListFilters',
    'grossListColumnsVisibility',
    'grossListAdvancedMode',
    'grossListReturnUrl'
  ],
  '/location-invoices/package-gp-list': [
    'gpPackageListFilters',
    'gpPackageListColumnsVisibility',
    'gpPackageListAdvancedMode',
    'gpPackageListReturnUrl'
  ],
  '/location-invoices/invoices-customer-type': ['customersSummaryFilter', 'customersSummaryViewMode'],
  '/location-invoices/invoices-deferred-type': ['deferredTypesSummaryFilter', 'deferredTypesSortState'],
  '/location-invoices/invoices-gross-profit': ['grossProfitSummaryFilter', 'grossProfitSortState'],
  '/location-invoices/package-gp-location': [
    'gpPackageByLocationSummaryFilter',
    'gpPackageByLocationSortState'
  ],
  '/location-invoices/package-gp-category': [
    'gpPackageByCategorySummaryFilter',
    'gpPackageByCategorySortState'
  ],
  '/location-invoices/performance-package-gp': ['packageUnperformedSummaryFilter'],
  '/location-invoices/category-overview': ['categoryOverviewFilter', 'categoryOverviewTableFilters'],
  '/tires/usaf-overview': ['usafOverviewFilters', 'usafListsAdvancedMode'],
  '/tires/usaf-orders': [
    'usafOrdersListFilters',
    'usafOrdersListColumnsVisibility',
    'usafListsAdvancedMode'
  ],
  '/tires/usaf-order-lines': [
    'usafOrderLinesListFilters',
    'usafOrderLinesListColumnsVisibility',
    'usafListsAdvancedMode'
  ],
  '/tires/usaf-auto-orders': [
    'usafAutoOrdersListFilters',
    'usafAutoOrdersListColumnsVisibility',
    'usafListsAdvancedMode'
  ],
  '/tires/usaf-leftovers': [
    'usafLeftoversListFilters',
    'usafLeftoversListColumnsVisibility',
    'usafListsAdvancedMode'
  ],
  '/tires/usaf-overdue-orders': [
    'usafOverdueOrdersListFilters',
    'usafOverdueOrdersListColumnsVisibility',
    'usafListsAdvancedMode'
  ],
  '/tires/usaf-invoices': [
    'usafInvoicesListFilters',
    'usafInvoicesListColumnsVisibility',
    'usafListsAdvancedMode'
  ],
  '/tires/order-refill': ['usafRefillSelectedLocationIds'],
  '/contacts/report': ['contactsReportConfig'],
  '/contacts/list': ['customersListFilters', 'customersListColumnsVisibility', 'contactsReportConfig'],
  '/communications/list': ['communicationsListTableFilters', 'communicationsListColumnsVisibility'],
  '/locations/status': ['locationsStatusSelectedLocationIds'],
  '/targets/objectives': [
    'weeklyTargetSelectedWeekNumber',
    'weeklyTargetSelectedDivision',
    'weeklyTargetScrollLocationId',
    'weeklyTargetSelectedLocationIds'
  ],
  '/targets/objectives-vs-comp': [
    'weeklyTargetSelectedWeekNumber',
    'weeklyTargetSelectedDivision',
    'weeklyTargetSelectedLocationIds'
  ],
  '/targets/rankings': [
    'weeklyTargetSelectedLocationIds',
    'weeklyTargetSelectedWeekNumber',
    'weeklyTargetSelectedDivision',
    'weeklyTargetRankingSortState',
    'weeklyTargetRankingSelectedRankingType'
  ],
  '/targets/period-rankings': [
    'periodTargetSelectedLocationIds',
    'periodTargetRankingFilter',
    'periodTargetSelectedDivision',
    'periodTargetRankingSortState',
    'periodTargetRankingSelectedRankingType'
  ],
  '/reports/calls': ['callsReportFilter'],
  '/reports/sales': ['salesReportFilter', 'salesReportSelectedObjectives'],
  '/reports/tires': ['tiresReportFilter'],
  '/reports/upsell': ['upsellFilter'],
  '/reports/upsell-summary': ['upsellFilter'],
  '/reports/upsell-list': ['upsellListFilters', 'upsellListColumnsVisibility', 'upsellListAdvancedMode'],
  '/payments/payments-list': [
    'paymentsListFilters',
    'paymentsListColumnsVisibility',
    'paymentsListAdvancedMode'
  ],
  '/tires/summary-program': ['tiresSummaryFilter', 'tiresSummaryViewMode'],
  '/tires/summary-levels': ['tiresByLevelSummaryFilter'],
  '/tires/summary-stockable': ['tiresByStockableSummaryFilter'],
  '/tires/summary-rotation': ['tiresByRotationSummaryFilter'],
  '/tires/summary-payment': ['tiresByPaymentSummaryFilter'],
  '/tires/list': [
    'tiresListFilters',
    'tiresListColumnsVisibility',
    'tiresListAdvancedMode',
    'tiresListReturnUrl'
  ],
  '/tires/list-full': [
    'tiresListFilters',
    'tiresListColumnsVisibility',
    'tiresListAdvancedMode',
    'tiresListReturnUrl'
  ],
  '/tires/inventory-summary': ['tireInventorySummaryFilter'],
  '/tires/inventory-list': [
    'tireInventoryListFilters',
    'tireInventoryListColumnsVisibility',
    'tireInventoryListAdvancedMode',
    'tireInventoryListReturnUrl'
  ],
  '/admin/user-list': [
    'adminUsersListFilters',
    'adminUsersListColumnsVisibility',
    'adminUsersListAdvancedMode'
  ],
  '/admin/locations-list': [
    'adminLocationsListFilters',
    'adminLocationsListColumnsVisibility',
    'adminLocationsListAdvancedMode'
  ],
  '/admin/announcements-list': [
    'adminAnnouncementsListFilters',
    'adminAnnouncementsListColumnsVisibility',
    'adminAnnouncementsListAdvancedMode'
  ],
  '/admin/call-tags': [
    'adminCallTagsListFilters',
    'adminCallTagsListColumnsVisibility',
    'adminCallTagsListAdvancedMode'
  ],
  '/admin/salaries-summary': ['salariesSummarySortState', 'salariesSummaryFilter'],
  '/admin/salaries-detail': ['salariesDetailFilter', 'salariesDetailReturnUrl'],
  '/admin/yearly-targets': [
    'adminYearlyTargetsFilters',
    'adminYearlyTargetsColumnsVisibility',
    'adminYearlyTargetsAdvancedMode'
  ],
  '/admin/monthly-targets': [
    'adminMonthlyTargetsFilters',
    'adminMonthlyTargetsColumnsVisibility',
    'adminMonthlyTargetsAdvancedMode'
  ],
  '/admin/view-targets': [
    'adminViewTargetsSelectedTab',
    'adminWeeklyTargetsSelectedWeek',
    'adminWeeklyTargetsLocationIds',
    'adminMonthlyViewTargetsSelectedMonth',
    'adminMonthlyViewTargetsLocationIds'
  ],
  '/targets/yearly-targets': [
    'yearlyTargetsFilters',
    'yearlyTargetsColumnsVisibility',
    'yearlyTargetsAdvancedMode'
  ],
  '/promotions/manage/list': ['adminPromotionsListSortState'],
  '/tracker/summary': ['trackerLocationIds'],
  '/tires/lost-tire': ['locationId'],
  '/contacts/communication-type': ['communicationTypeFilter'],
  '/targets/history': ['targetsHistoryFilter'],
  '/tires/lost-tire-list': [
    'lostTiresListFilters',
    'lostTiresListColumnsVisibility',
    'lostTiresListAdvancedMode'
  ],
  '/stockable/items': ['locationId'],
  '/attendance': ['attendanceSelectedWeekNumber', 'attendanceActiveCards'],
  '/employee/list': ['employeeListFilters', 'employeeListColumnsVisibility', 'employeeListAdvancedMode'],
  '/employee/labor-summary': ['laborSummaryFilter', 'laborSummarySortState'],
  '/employee/back-shop-summary': ['technicianSummaryFilter', 'technicianSummarySortState'],
  '/employee/back-shop-list': [
    'technicianListEmployeeId',
    'technicianListFilters',
    'technicianListColumnsVisibility',
    'technicianListAdvancedMode',
    'technicianListSelectedDateInfo'
  ],
  '/employee/front-shop-summary': ['serviceAdvisorSummaryFilter', 'serviceAdvisorSummarySortState'],
  '/employee/front-shop-list': [
    'serviceAdvisorListEmployeeId',
    'serviceAdvisorListFilters',
    'serviceAdvisorListColumnsVisibility',
    'serviceAdvisorListAdvancedMode',
    'serviceAdvisorListSelectedDateInfo'
  ],
  '/employee/employee-efficiency-moving-average': [
    'employeeEfficiencyRankingSelectedLocationIds',
    'employeeEfficiencyRankingSelectedType'
  ],
  '/scheduler/location': [
    'schedulerSelectedShopId',
    'schedulerSelectedWeekNumber',
    'schedulerShowAllEmployees'
  ],
  '/scheduler/list': ['schedulerListFilter', 'schedulerSelectedWeekNumber'],
  '/scheduler/attendance': ['scheduleAttendanceFilter'],
  '/reports/compare': [
    'compareReportSelectedObjectives',
    'compareReportFilter',
    'compareReportDisplayOptions'
  ],
  '/reports/compare-objectives': [
    'compareObjectivesByGroupSelectedObjectives',
    'compareObjectivesByGroupNumberOfMonths',
    'compareObjectivesByGroupLocationIds'
  ],
  '/reports/compare-objectives-regional': [
    'compareObjectivesByRegionalSelectedObjectives',
    'compareObjectivesByRegionalNumberOfMonths',
    'compareObjectivesByRegionalLocationIds'
  ],
  '/reports/moving-average': [
    'objectivesRankingSelectedObjective',
    'objectivesRankingSelectedLocationIds'
  ],
  '/reports/adjusted-gross-profit': ['adjustedGPFilter'],
  '/vendors/summary': ['vendorsFilter'],
  '/vendors/levels': ['vendorsFilter'],
  '/vendors/preferred': [
    'preferredVendorsFilters',
    'preferredVendorsColumnsVisibility',
    'preferredVendorsAdvancedMode'
  ],
  '/vendors/list': ['vendorsListFilters', 'vendorsListColumnsVisibility', 'vendorsListAdvancedMode'],
  '/location-invoices/categories-moving-average': [
    'categoryMovingAverageSelectedCategory',
    'categoryMovingAverageSelectedLocationIds'
  ],
  '/fluids/summary': ['fluidsSummaryFilter', 'fluidsSummarySortState'],
  '/fluids/list': ['fluidsListFilters', 'fluidsListColumnsVisibility', 'fluidsListAdvancedMode'],
  '/addons/summary': ['addonsSummaryFilter', 'addonsSummarySortState'],
  '/official-forms/cash-drawer-summary': ['cashDrawerFilter', 'cashDrawerSortState'],
  '/official-forms/weekly-tire-count-summary': ['weeklyTireCountFilter', 'weeklyTireCountSortState'],
  '/official-forms/weekly-tire-report-summary': ['weeklyTireReportFilter', 'weeklyTireReportSortState'],
  '/official-forms/curb-appeal-summary': ['curbAppealFilter', 'curbAppealSortState'],
  '/official-forms/showroom-summary': ['showroomFilter', 'showroomSortState'],
  '/employee/invoice-package-lines': [
    'invoicePackageLinesFilters',
    'invoicePackageLinesColumnsVisibility',
    'invoicePackageLinesAdvancedMode',
    'invoicePackageLinesReturnUrl'
  ],
  '/reports/daily-average': [
    'dailyAverageSelectedMetric',
    'dailyAverageSelectedLocationIds',
    'dailyAverageSelectedDateInfo',
    'dailyAverageSelectedDateFilter'
  ],
  '/targets/weekly-average': [
    'targetsDailyAverageSelectedObjective',
    'targetsDailyAverageSelectedLocationIds',
    'targetsDailyAverageSelectedWeeks'
  ],
  '/call-intelligence/dashboard': ['callIntelligenceDashboardFilter'],
  '/call-intelligence/drilldown': [
    'callIntelligenceDrilldownFilter',
    'callIntelligenceDrilldownSortState'
  ],
  '/call-intelligence/leads': [
    'callIntelligenceLeadsListFilters',
    'callIntelligenceLeadsListColumnsVisibility',
    'callIntelligenceLeadsListAdvancedMode',
    'callIntelligenceActiveLeadsId',
    'callIntelligenceReturnUrl'
  ],
  '/call-intelligence/leads-cost': [
    'callIntelligenceCostLeadsListFilters',
    'callIntelligenceCostLeadsListColumnsVisibility',
    'callIntelligenceCostLeadsListAdvancedMode',
    'callIntelligenceCostActiveLeadsId'
  ],
  '/dashboard/week-over-week': ['wowSelectedLocationIds', 'wowSelectedWeek', 'wowSelectedCompareWeek']
}

export const PersistFilters: FilterStateKeys[] = [
  'colorMode',
  'showLargeMenu',
  'collapsedMenuSections',
  'showAppliedTableFilters',
  'weeklyTargetExpandedShopsId',
  'vendorsExpandedShopsId',
  'adminShopTiresExpandedShopsId',
  'promotionsExpandedShopsId',
  'promotionsUsersExpandedIds',
  'workOrdersListColumnsVisibility',
  'receivableColumnsVisibility',
  'invoicesListColumnsVisibility',
  'invoiceLinesListColumnsVisibility',
  'grossListColumnsVisibility',
  'gpPackageListColumnsVisibility',
  'customersListColumnsVisibility',
  'communicationsListColumnsVisibility',
  'paymentsListColumnsVisibility',
  'callIntelligenceLeadsListColumnsVisibility',
  'callIntelligenceCostLeadsListColumnsVisibility',
  'tiresListColumnsVisibility',
  'tireInventoryListColumnsVisibility',
  'usafOrdersListColumnsVisibility',
  'usafOrderLinesListColumnsVisibility',
  'usafInvoicesListColumnsVisibility',
  'adminUsersListColumnsVisibility',
  'adminLocationsListColumnsVisibility',
  'adminAnnouncementsListColumnsVisibility',
  'adminCallTagsListColumnsVisibility',
  'adminYearlyTargetsColumnsVisibility',
  'adminMonthlyTargetsColumnsVisibility',
  'yearlyTargetsColumnsVisibility',
  'lostTiresListColumnsVisibility',
  'employeeListColumnsVisibility',
  'technicianListColumnsVisibility',
  'serviceAdvisorListColumnsVisibility',
  'vendorsListColumnsVisibility',
  'fluidsListColumnsVisibility',
  'upsellListColumnsVisibility',
  'invoicePackageLinesColumnsVisibility',
  'contactsReportConfig',
  'compareReportShowCharts'
]
